const state = {
    loggedin: false,
    username: '',
    auth: null,
    rights: null,
    user: null
};
export default state;
